<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Nodejs',
    data () {
      return {
        cards: [{
          title: 'nodejs.bj.title',
          img: {link: 'static/img/njsAccueil.jpg', alt: 'nodejs.bj.alt.pict'},
          desc: 'nodejs.bj.desc',
          action: 'nodejs.bj.action'
        }, {
          title: 'nodejs.f1.title',
          img: {link: 'static/img/node_js_site_iut.jpg', alt: 'nodejs.f1.alt.pict'},
          desc: 'nodejs.f1.desc',
          action: 'nodejs.f1.action'
        }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Nodejs.vue